import React, { useEffect, useRef } from 'react'

import { useDistributionContext } from 'pages/Distribution/Distribution'

import img1 from 'assets/images/distributionPage/1.png'
import img2 from 'assets/images/distributionPage/2.png'
import img3 from 'assets/images/distributionPage/3.png'
import img4 from 'assets/images/distributionPage/4.png'
import img5 from 'assets/images/distributionPage/5.png'
import img6 from 'assets/images/distributionPage/6.png'

import classes from './Background.module.scss'
import classNames from 'classnames'

export const DistributionFirstBlockBackground = ({
  parentID,
}: {
  parentID: string
}): JSX.Element => {
  const images = [img1, img2, img3, img4, img5, img6]
  const speed = [5, 5, 2, 6, 8, 2]
  const className = classes.img
  const refs = useRef<HTMLImageElement[]>([])
  const { isPartnerFormOpened } = useDistributionContext()
  const wrapperClasses = classNames({
    [classes.wrapper]: true,
    [classes.hidden]: isPartnerFormOpened,
  })

  useEffect(() => {
    const parentElement = document.getElementById(parentID)
    parentElement?.addEventListener('mousemove', paralax)

    return () => parentElement?.removeEventListener('mousemove', paralax)
  })

  function paralax(e: MouseEvent) {
    refs.current.forEach(element => {
      // можно было бы не анимировать картинки, когда блок скрыт,
      // но тогда при закрытии формы анимация "дергается",
      // поэтому при скрытом блоке картинки тоже двигаются
      if (!element) {
        return
      }
      const speed = Number(element?.getAttribute('data-speed'))
      const x = (window.innerWidth - e.pageX * speed) / 100
      // const y = (window.innerHeight - e.pageY * speed) / 100

      element.style.transform = `translateX(${x}px)`
    })
  }

  return (
    <div className={wrapperClasses}>
      {images.map((img, imgIndex) => {
        return (
          <img
            ref={el => ((refs.current[imgIndex] as any) = el)}
            className={className}
            src={img}
            data-speed={speed[imgIndex]}
            key={imgIndex}
            alt=""
          />
        )
      })}
    </div>
  )
}
